import React, { useEffect, useRef, useState } from 'react';
import AD_CONFIG from './AdConfig';

const AdSenseAd = ({ 
  adSlot, 
  adFormat = "fluid", 
  adLayoutKey = "-fb+5w+4e-db+86",
  style = { display: 'block' },
  className = "adsbygoogle"
}) => {
  const adRef = useRef(null);
  const [adLoaded, setAdLoaded] = useState(false);

  useEffect(() => {
    if (!AD_CONFIG.enabled) {
      console.log('AdSense ads are disabled via configuration');
      return;
    }

    console.log('AdSense: Attempting to load ad', {
      slot: adSlot,
      client: AD_CONFIG.clientId,
      adsbygoogle: !!window.adsbygoogle,
      adRef: !!adRef.current
    });

    const initializeAd = () => {
      if (adLoaded) return; // Prevent multiple initializations
      
      if (window.adsbygoogle && adRef.current && !adRef.current.hasAttribute('data-adsbygoogle-status')) {
        console.log('AdSense: Pushing ad to queue');
        try {
          (window.adsbygoogle = window.adsbygoogle || []).push({});
          setAdLoaded(true);
        } catch (error) {
          console.error('AdSense push error:', error);
        }
      } else {
        console.log('AdSense: Waiting for conditions', {
          adsbygoogle: !!window.adsbygoogle,
          adRef: !!adRef.current,
          alreadyProcessed: adRef.current?.hasAttribute('data-adsbygoogle-status'),
          adLoaded
        });
      }
    };

    // Use requestAnimationFrame to ensure DOM is ready
    const frame = requestAnimationFrame(() => {
      initializeAd();
      // Also try with a small delay as backup
      setTimeout(initializeAd, 100);
    });

    return () => {
      cancelAnimationFrame(frame);
    };
  }, [adSlot, adLoaded]);

  // Don't render if ads are disabled
  if (!AD_CONFIG.enabled) {
    return null;
  }

  // Show placeholder in debug mode
  if (AD_CONFIG.debug) {
    return (
      <div className="adsense-container">
        <div style={{ 
          padding: '20px', 
          backgroundColor: '#f0f0f0', 
          border: '2px dashed #ccc',
          textAlign: 'center',
          color: '#666'
        }}>
          [DEBUG: AdSense Ad Placeholder - Slot: {adSlot}]<br/>
          Script Loaded: {window.adsbygoogle ? '✅' : '❌'}<br/>
          Client ID: {AD_CONFIG.clientId}<br/>
          Environment: {process.env.NODE_ENV}<br/>
          <small>Note: Real ads may not show on localhost</small>
        </div>
      </div>
    );
  }

  return (
    <div className="adsense-container">
      <ins 
        ref={adRef}
        className={className}
        style={style}
        data-ad-format={adFormat}
        data-ad-layout-key={adLayoutKey}
        data-ad-client={AD_CONFIG.clientId}
        data-ad-slot={adSlot}
      />
    </div>
  );
};

export default AdSenseAd;
